module.exports = __webpack_public_path__ + "img/5-1.ecae9eb0.png";